import axiosInstance from "../api/axiosInstance";
import React, { useState } from "react"
import { Container, Form, Button, Accordion } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import { 
    FaHeartbeat, 
    FaInfoCircle, 
    FaExclamationTriangle, 
    FaExchangeAlt, 
    FaShieldAlt, 
    FaInbox, 
    FaSearch, 
    FaBuilding, 
    FaBarcode, 
    FaCalendarAlt 
} from "react-icons/fa";
import { GiMedicines } from "react-icons/gi";

const Medicine = () => {
    const medicine = useSelector((state) => state.medicine);
    const privateData = useSelector((state) => state.privateData);

    const [medicineName, setMedicineName] = useState("");
    const [medicineResults, setMedicineResults] = useState([]);
    const [loading, setLoading] = useState(false);

    const fnObj = {
        medicineInfo: {
            itemName: '제품명',
            entpName: '업체명',
            itemSeq: '품목기준코드',
            efcyQesitm: '효능',
            useMethodQesitm: '사용법',
            atpnWarnQesitm: '주의사항1',
            atpnQesitm: '주의사항2',
            intrcQesitm: '상호작용',
            seQesitm: '부작용',
            depositMethodQesitm: '보관법',
            openDe: '공개일자',
            updateDe: '수정일자',
            itemImage: '이미지',
            bizrno: '사업자등록번호'
        },
        getParseXMLToJSON(xmlString) {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlString, "text/xml");

            const xmlToJson = (node) => {
                const obj = {};
                if (node.nodeType === 1) { // Element node
                    if (node.attributes.length > 0) {
                        obj["@attributes"] = {};
                        for (let attr of node.attributes) {
                            obj["@attributes"][attr.nodeName] = attr.nodeValue;
                        }
                    }
                } else if (node.nodeType === 3) { // Text node
                    return node.nodeValue.trim();
                }

                if (node.childNodes.length > 0) {
                    for (let child of node.childNodes) {
                        const nodeName = child.nodeName;
                        const jsonChild = xmlToJson(child);

                        if (jsonChild) {
                            if (obj[nodeName] === undefined) {
                                obj[nodeName] = jsonChild;
                            } else {
                                if (!Array.isArray(obj[nodeName])) {
                                    obj[nodeName] = [obj[nodeName]];
                                }
                                obj[nodeName].push(jsonChild);
                            }
                        }
                    }
                }
                return obj;
            };

            return { [xmlDoc.documentElement.nodeName]: xmlToJson(xmlDoc.documentElement) };
        },
        getSearch() {
            if (!medicineName.trim()) {
                alert("약 이름을 입력해주세요.");
                return;
            }
            (async () => {
                setLoading(true);
                try {
                    const response = await axiosInstance.get(`${medicine.medicineUrl}?serviceKey=${privateData.serviceKey}&itemName=${medicineName}`, {
                        headers: {
                            'Accept': 'application/xml',
                        }
                    });
                    let items = fnObj.getParseXMLToJSON(response.data).response.body.items.item;
                    if (!items) {
                        setMedicineResults([]);
                        alert('입력하신 약 정보가 없습니다.');
                        setLoading(false);
                        return;
                    }
                    let dataList = Array.isArray(items) ? items : [items];
                    setMedicineResults(dataList);

                } catch (error) {
                    console.log(error);
                    alert('입력하신 약 정보가 없습니다.');
                }
                setLoading(false);
            })();
        },
        getKeyDown(event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                fnObj.getSearch(); // 엔터 키가 눌리면 검색 실행
            }
        }
    }

    const getPropValue = (med, propKey) => {
        if (!med || !med[propKey]) return '';
        const valObj = med[propKey];
        if (typeof valObj === 'object') {
            return valObj['#text'] || '';
        }
        return valObj || '';
    };

    const cleanText = (text) => {
        if (!text) return '-';
        // HTML 태그 제거 및 정돈
        return text.replace(/<[^>]*>?/gm, '').trim();
    };

    const detailSections = [
        { key: 'efcyQesitm', label: '효능 및 효과', icon: <FaHeartbeat className="text-danger me-2" /> },
        { key: 'useMethodQesitm', label: '사용 방법 (복용법)', icon: <FaInfoCircle className="text-primary me-2" /> },
        { key: 'atpnWarnQesitm', label: '경고 및 주의사항 (필독)', icon: <FaExclamationTriangle className="text-danger me-2" /> },
        { key: 'atpnQesitm', label: '일반 주의사항', icon: <FaExclamationTriangle className="text-warning me-2" /> },
        { key: 'intrcQesitm', label: '상호작용 (피해야 할 약/음식)', icon: <FaExchangeAlt className="text-secondary me-2" /> },
        { key: 'seQesitm:부작용', label: '부작용 및 이상반응', icon: <FaShieldAlt className="text-warning me-2" />, realKey: 'seQesitm' },
        { key: 'depositMethodQesitm', label: '보관 및 폐기 방법', icon: <FaInbox className="text-success me-2" /> }
    ];

    return (
        <div className="medical-wrapper">
            {
                loading && (
                    <div className="loading-overlay">
                        <div className="loading-spinner">
                            <img
                                src="/pepe.png"
                                alt="loading"
                                style={{
                                    width: "50px",
                                    opacity: 0.7,
                                    marginBottom: "10px"
                                }}
                            />
                            <ClipLoader color="#ffffff" size={50} />
                            <p className="mt-2">찾는 중...</p>
                        </div>
                    </div>
                )
            }
            <Container>
                {/* 검색 필터 바 */}
                <div className="medical-filter-card d-flex align-items-center justify-content-between flex-wrap gap-3">
                    <h4 className="m-0 fw-bold d-flex align-items-center gap-2">
                        <GiMedicines className="text-primary" /> 의약품 상세 검색
                    </h4>
                    <span className="text-muted small">
                        식약처에 등록된 의약품의 상세 효능 및 주의사항을 정확하게 조회합니다.
                    </span>
                </div>

                {/* 검색 입력창 */}
                <Form className="d-flex mb-4" onSubmit={(e) => e.preventDefault()}>
                    <Form.Control
                        type="text"
                        placeholder="약 이름을 입력하세요. (예: 타이레놀)"
                        value={medicineName}
                        onChange={(e) => setMedicineName(e.target.value)}
                        onKeyDown={fnObj.getKeyDown}
                        className="medical-search-input"
                    />
                    <Button className="medical-search-btn" onClick={fnObj.getSearch}>
                        <FaSearch className="me-1" /> 검색
                    </Button>
                </Form>

                {/* 검색 결과 */}
                {medicineResults.length > 0 &&
                    medicineResults.map((med, index) => {
                        const name = getPropValue(med, 'itemName');
                        const company = getPropValue(med, 'entpName');
                        const seq = getPropValue(med, 'itemSeq');
                        const image = getPropValue(med, 'itemImage');
                        const openDate = getPropValue(med, 'openDe');
                        const updateDate = getPropValue(med, 'updateDe');

                        return (
                            <div className="medicine-result-card" key={index}>
                                {/* Hero 상단 정보 */}
                                <div className="medicine-hero-section">
                                    <div className="medicine-image-wrapper">
                                        {image ? (
                                            <img src={image} className="medicine-img" alt={name} />
                                        ) : (
                                            <div className="medicine-no-img d-flex flex-column align-items-center justify-content-center h-100">
                                                <GiMedicines size={40} className="text-secondary mb-1" style={{ opacity: 0.5 }} />
                                                <span>이미지 없음</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="medicine-meta-info">
                                        <h3 className="medicine-name">{name}</h3>
                                        <div className="medicine-company d-flex align-items-center gap-1">
                                            <FaBuilding className="text-muted" size={14} /> {company}
                                        </div>
                                        <div className="d-flex flex-wrap gap-2 mt-2" style={{ fontSize: '0.8rem' }}>
                                            <span className="medicine-code-badge d-flex align-items-center gap-1">
                                                <FaBarcode size={12} /> 코드: {seq}
                                            </span>
                                            {openDate && (
                                                <span className="medicine-code-badge d-flex align-items-center gap-1">
                                                    <FaCalendarAlt size={12} /> 최초공개: {openDate.substring(0, 10)}
                                                </span>
                                            )}
                                            {updateDate && (
                                                <span className="medicine-code-badge d-flex align-items-center gap-1">
                                                    <FaCalendarAlt size={12} /> 최종수정: {updateDate.substring(0, 10)}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* 상세 정보 아코디언 */}
                                <Accordion defaultActiveKey="0" className="medicine-accordion">
                                    {detailSections.map((sec, secIdx) => {
                                        const key = sec.realKey || sec.key;
                                        const rawVal = getPropValue(med, key);
                                        const val = cleanText(rawVal);
                                        if (val === '-' || !val) return null; // 빈 항목은 렌더링하지 않음

                                        return (
                                            <Accordion.Item eventKey={String(secIdx)} key={sec.key}>
                                                <Accordion.Header className="d-flex align-items-center">
                                                    {sec.icon} {sec.label}
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    {val}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        );
                                    })}
                                </Accordion>
                            </div>
                        );
                    })}
            </Container>
        </div>
    );
}

export { Medicine };